import { render, staticRenderFns } from "./ExportAttributes.vue?vue&type=template&id=47423976"
import script from "./ExportAttributes.vue?vue&type=script&lang=ts"
export * from "./ExportAttributes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports